import { render, staticRenderFns } from "./DetailPaket.vue?vue&type=template&id=1250bae5&"
import script from "./DetailPaket.vue?vue&type=script&lang=js&"
export * from "./DetailPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports